export enum SessionFilterEnum {
    ALL = 'all',
    TERMINATED = 'terminated',
    PLANNED = 'planned',
}
